import React from 'react';
import Head from 'next/head';
import styles from './ios-newsletter.module.scss';
import SignUpPanel from '../../components/Conjure/SignUp';
import handsIcon from './hands.ico';

class ConjureErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[Conjure] client-side exception:', error, info);
  }

  render() {
    if (this.state.error) return null;
    return this.props.children;
  }
}

function ConjureIOSNewsletter() {
  return (
    <div className={styles.conjurePage}>
      <Head>
        <link rel='icon' href={handsIcon} sizes='any' />
        <link rel='shortcut icon' href={handsIcon} />
        <meta
          name='description'
          content='Conjure iOS Newsletter - What is reality hiding from you?'
        />
        <meta
          property='og:description'
          content='Conjure iOS Newsletter - What is reality hiding from you?'
        />
      </Head>

      <div className={styles.conjureContent}>
        <SignUpPanel iosOnly showFormByDefault hideTagline buttonText="STAY NOTIFIED" />
      </div>

      <footer className={styles.privacyFooter}>
        <a href='/policies/privacy-policy'>
          PRIVACY POLICY
        </a>
      </footer>
    </div>
  );
}

export default function ConjureIOSNewsletterPage() {
  return (
    <ConjureErrorBoundary>
      <ConjureIOSNewsletter />
    </ConjureErrorBoundary>
  );
}
